import ModalCustomerIneligible from './ModalCustomerIneligible.vue';

export { ModalCustomerIneligible };